import { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { authService } from '../services/authService';
import { Identity } from '../types/auth';

interface AuthContextType {
  identity: Identity | null;
  isLoading: boolean;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [identity, setIdentity] = useState<Identity | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    authService.getWhoAmI()
      .then(response => {
        if (response.ok) {
          setIdentity(response.identity);
        }
      })
      .catch(console.error)
      .finally(() => setIsLoading(false));
  }, []);

  const logout = () => {
    authService.logout();
    setIdentity(null);
  };

  return (
    <AuthContext.Provider value={{ identity, isLoading, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
